<!-- Cabecera de bienvenida -->
<div class="selector-header">
  <div class="selector-header-content">
    <h2 class="selector-title">{{ 'USER.WELCOME' | translate }} {{ user.name }}</h2>
    <p class="selector-subtitle">{{ 'ORGANITZATION.SELECT_APP' | translate }}</p>
  </div>
  <p-button
    [label]="'USER.CLOSE_SESSION' | translate"
    styleClass="btn-logout"
    [text]="true"
    severity="secondary"
    icon="pi pi-sign-out"
    (onClick)="onLogout()"
  ></p-button>
</div>

<!-- Región principal del selector -->
<div
  role="region"
  [attr.aria-label]="'USER.APP_SELECTOR_REGION' | translate"
>

  <!-- Barra de búsqueda -->
  <!-- <div *ngIf="!loading && !error" class="selector-search">
    <div class="search-input-wrapper">
      <i class="pi pi-search search-icon"></i>
      <input
        pInputText
        type="text"
        class="search-input"
        [formControl]="searchControl"
        [placeholder]="'USER.SEARCH_APPS' | translate"
      />
      <button
        *ngIf="searchControl.value"
        type="button"
        class="search-clear"
        (click)="clearSearch()"
        [attr.aria-label]="'USER.CLEAR_SEARCH' | translate"
      >
        <i class="pi pi-times"></i>
      </button>
    </div>
    <span
      class="search-counter"
      aria-live="polite"
      aria-atomic="true"
    >
      {{ 'USER.APPS_FOUND' | translate: { count: (filteredCount$ | async) } }}
    </span>
  </div> -->

  <!-- Lista de apps -->
  <div
    *ngIf="!loading && !error"
    class="apps-grid mt-4"
    aria-busy="false"
  >
    <div
      *ngFor="let app of (filteredApps$ | async); trackBy: trackByApp"
      class="app-card-wrapper"
    >
      <sw-app-card
        [app]="app"
        (appSelected)="onSelectApp($event)"
      ></sw-app-card>
    </div>
  </div>

  <!-- Empty state — sin apps tras filtrar o lista vacía -->
  <div
    *ngIf="!loading && !error && ((filteredApps$ | async)?.length === 0)"
    class="selector-empty"
    role="status"
    aria-live="polite"
  >
    <i class="pi pi-inbox selector-empty-icon"></i>
    <p>{{ 'USER.NO_APPS_AVAILABLE' | translate }}</p>
    <span>{{ 'USER.CONTACT_ADMIN' | translate }}</span>
  </div>

  <!-- Error state — mensaje de error externo con opción de reintentar -->
  <div
    *ngIf="error !== null"
    class="selector-error"
    role="alert"
    aria-live="assertive"
  >
    <i class="pi pi-exclamation-triangle selector-error-icon"></i>
    <p>{{ error | translate }}</p>
    <p-button
      (onClick)="onRetry()"
      [label]="'USER.RETRY' | translate"
      severity="danger"
      [outlined]="true"
      [disabled]="isRetrying"
    ></p-button>
  </div>

  <!-- Skeleton de carga — grid de cards simuladas mientras loading === true -->
  <div
    *ngIf="loading"
    class="apps-grid skeleton-grid"
    aria-busy="true"
    aria-live="polite"
    aria-atomic="true"
    [attr.aria-label]="'USER.LOADING_APPS' | translate"
  >
    <div
      *ngFor="let item of skeletonItems"
      class="skeleton-card"
    >
      <!-- Avatar / icono de la app -->
      <div class="skeleton-card__avatar">
        <p-skeleton
          [shape]="'rectangle'"
          width="3rem"
          height="3rem"
          borderRadius="8px"
        ></p-skeleton>
      </div>

      <!-- Líneas de texto: nombre y organización -->
      <div class="skeleton-card__body">
        <p-skeleton
          [shape]="'rectangle'"
          width="70%"
          height="1rem"
          borderRadius="4px"
        ></p-skeleton>
        <p-skeleton
          [shape]="'rectangle'"
          width="50%"
          height="0.8rem"
          borderRadius="4px"
          styleClass="mt-2"
        ></p-skeleton>
      </div>

      <!-- Botón de acción -->
      <div class="skeleton-card__footer">
        <p-skeleton
          [shape]="'rectangle'"
          width="100%"
          height="2rem"
          borderRadius="6px"
        ></p-skeleton>
      </div>
    </div>
  </div>

</div>

